/**
 * CardItem component.
 * This component represents an individual card item in the Knowledge Center and Video Course.
 */

import React from 'react';
import { Box, Icon, Text, Flex, Button, AspectRatio } from '@chakra-ui/react';
import { AiOutlineClockCircle } from 'react-icons/all';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import CategoryBadge from '../Badge/CategoryBadge';
import { GetAuthData } from '../../../../misc/GetAuthData';
import { MdOutlineInfo } from 'react-icons/md';
import { FaUsers } from 'react-icons/fa';
import { FaCalendar } from 'react-icons/fa';
import { FaPlayCircle } from 'react-icons/fa';

const CardItem = ({ item, spacing = true, accessFor }) => {
  const useAuth = GetAuthData();
  const history = useHistory();

  const urlDetail =
    accessFor === 'kursus-video'
      ? '/detail/kursus-video'
      : '/detail/pengetahuan';

  const classItem =
    accessFor === 'kursus-video' ? 'video-course-item' : 'pengetahuan-item';

  const formatTanggal = (tanggal) => {
    if (!tanggal) return '-';
    const date = new Date(tanggal);
    return new Intl.DateTimeFormat('id-ID', {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    }).format(date);
  };

  return (
    <Box
      h="auto"
      borderRadius="lg"
      overflow="hidden"
      boxShadow="md"
      mr={{ base: 0, md: spacing ? 8 : 0 }}
    >
      {/* Thumbnail */}
      <AspectRatio ratio={16 / 9}>
        <Box
          background={`url(${item.thumbnail}) center/cover no-repeat`}
          className={classItem}
          position="relative"
        >
          {item?.category === 'video' && (
            <Flex
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              align="center"
              justify="center"
            >
              {/* SVG play icon */}
              {/* (SVG kode kamu taruh di sini) */}
            </Flex>
          )}
        </Box>
      </AspectRatio>

      {/* Content */}
      <Box bg="white" py={4} px={4}>
        <Flex direction="column" gap={2}>
          {/* Title */}
          <Text
            fontSize={{ base: 'md', md: 'lg' }}
            fontWeight="bold"
            noOfLines={2}
            color="black"
          >
            {item.title}
          </Text>

          {/* Jadwal */}
          <Flex align="center" fontSize="sm" color="gray.600">
            <Icon as={FaCalendar} boxSize={4} color="orange" mr={2} />
            <Text>
              {formatTanggal(item?.jadwal_mulai)} s.d{' '}
              {formatTanggal(item?.jadwal_selesai)}
            </Text>
          </Flex>

          {/* Peserta */}
          <Flex align="center" fontSize="sm" color="gray.600">
            <Icon as={FaUsers} boxSize={4} color="orange" mr={2} />
            <Text>{item?.count_peserta} Peserta</Text>
          </Flex>

          {/* Ditonton */}
          <Flex align="center" fontSize="sm" color="gray.600">
            <Icon as={FaPlayCircle} boxSize={4} color="orange" mr={2} />
            <Text>{item?.review_count} kali ditonton</Text>
          </Flex>

          {/* Button */}
          <Button
            mt={4}
            colorScheme="green"
            variant="solid"
            w="full"
            h={{ base: '40px', md: '48px' }}
            fontSize={{ base: 'sm', md: 'md' }}
            onClick={() => {
              if (useAuth !== null) {
                window.location.href = `${urlDetail}/${item.id}`;
              } else {
                history.push('/login');
                window.scrollTo(0, 0);
              }
            }}
          >
            Lihat Selengkapnya
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default CardItem;
